import { useEffect, useState, FC } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    Divider,
    Table,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
    TableContainer,
    Typography
  } from "@mui/material";
import { ComponenteProjetoComQuantidade } from "../../../types";
import { FullWidthButton } from "src/framework/components/buttons/FullWidthButton";
import { ComponenteProvider } from "src/providers/estoque/ComponenteProvider";

interface ModalInfoInativosProperties {
    itensInativos: Pick<ComponenteProjetoComQuantidade, "nome" | "categoria_componentes_id">[];
    open: boolean;
    onClose: () => void;
}

const ModalInfoInativos: FC<ModalInfoInativosProperties> = ({
    open = true,
    itensInativos,
    onClose,
}) => {
    const [estruturasState, setEstruturasState] = useState<Pick<ComponenteProjetoComQuantidade, "nome">[]>([]);
    const [acessoriosState, setAcessoriosState] = useState<Pick<ComponenteProjetoComQuantidade, "nome">[]>([]);
    const [inversoresState, setInversoresState] = useState<Pick<ComponenteProjetoComQuantidade, "nome">[]>([]);
    const [modulosState, setModulosState] = useState<Pick<ComponenteProjetoComQuantidade, "nome">[]>([]);
    const [bateriasState, setBateriasState] = useState<Pick<ComponenteProjetoComQuantidade, "nome">[]>([]);
    const [controladoresState, setControladoresState] = useState<Pick<ComponenteProjetoComQuantidade, "nome">[]>([]);
    const [iluminacaoState, setIluminacaoState] = useState<Pick<ComponenteProjetoComQuantidade, "nome">[]>([]);

    useEffect(() => {
        const sortItens = async () => {
            const componentes = itensInativos || []
            const componentProvider = new ComponenteProvider();
            const [categoriasEstruturas, categoriasAcessorios, categoriasInversores, categoriasModulos, categoriasBaterias, categoriasControladores, categoriasIluminacao] = await Promise.all([
                componentProvider.buscarCategoriasPorGrupo('itens_estrutura'),
                componentProvider.buscarCategoriasPorGrupo('acessorios'),
                componentProvider.buscarCategoriasPorGrupo('inversores'),
                componentProvider.buscarCategoriasPorGrupo('modulos'),
                componentProvider.buscarCategoriasPorGrupo('baterias'),
                componentProvider.buscarCategoriasPorGrupo('controladores'),
                componentProvider.buscarCategoriasPorGrupo('iluminacao'),
            ])
            const CategoriasEstruturasIds = categoriasEstruturas.map(item => item.id);
            const CategoriasAcessoriosIds = categoriasAcessorios.map(item => item.id);
            const CategoriasInversoresIds = categoriasInversores.map(item => item.id);
            const CategoriasModulosIds = categoriasModulos.map(item => item.id);
            const CategoriasBateriasIds = categoriasBaterias.map(item => item.id);
            const CategoriasControladoresIds = categoriasControladores.map(item => item.id);
            const CategoriasIluminacaoIds = categoriasIluminacao.map(item => item.id);

            const estruturas = componentes.filter((rec) => CategoriasEstruturasIds.includes(rec.categoria_componentes_id || 0));
            const acessorios = componentes.filter((rec) => CategoriasAcessoriosIds.includes(rec.categoria_componentes_id || 0));
            const inversores = componentes.filter((rec) => CategoriasInversoresIds.includes(rec.categoria_componentes_id || 0));
            const modulos = componentes.filter((rec) => CategoriasModulosIds.includes(rec.categoria_componentes_id || 0));
            const baterias = componentes.filter((rec) => CategoriasBateriasIds.includes(rec.categoria_componentes_id || 0));
            const controladores = componentes.filter((rec) => CategoriasControladoresIds.includes(rec.categoria_componentes_id || 0));
            const iluminacao = componentes.filter((rec) => CategoriasIluminacaoIds.includes(rec.categoria_componentes_id || 0));

            setEstruturasState(estruturas);
            setAcessoriosState(acessorios);
            setInversoresState(inversores);
            setModulosState(modulos);
            setBateriasState(baterias);
            setControladoresState(controladores);
            setIluminacaoState(iluminacao);
        }
        sortItens();
    }, [itensInativos]);

    return<>
    
        {( estruturasState?.length > 0 
        || acessoriosState?.length > 0
        || inversoresState?.length > 0
        || modulosState?.length > 0
        || bateriasState?.length > 0
        || controladoresState?.length > 0
        || iluminacaoState?.length > 0) && (
        <Dialog 
            open={open}
            maxWidth={'md'}
        >
            <DialogTitle id="dialog-itens-inativos">
                <Typography style={{fontWeight: "bold"}}>
                    Atenção!
                </Typography>
                <Divider variant="fullWidth" />
            </DialogTitle>
            <DialogContent>
                <Box >
                    <Typography style={{color:"#838383"}}>
                        Os itens abaixo não estão mais disponíveis:
                    </Typography>
                </Box>
                <Box>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{fontWeight: "bold"}}>Nome</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {modulosState.map(item=>(
                                    <TableRow>
                                        <TableCell>{item.nome}</TableCell>
                                    </TableRow>
                                ))}
                                {inversoresState.map(item=>(
                                    <TableRow>
                                        <TableCell>{item.nome}</TableCell>
                                    </TableRow>
                                ))}
                                {estruturasState.map(item=>(
                                    <TableRow>
                                        <TableCell>{item.nome}</TableCell>
                                    </TableRow>
                                ))}
                                {acessoriosState.map(item=>(
                                    <TableRow>
                                        <TableCell>{item.nome}</TableCell>
                                    </TableRow>
                                ))}
                                {bateriasState.map(item=>(
                                    <TableRow>
                                        <TableCell>{item.nome}</TableCell>
                                    </TableRow>
                                ))}
                                {controladoresState.map(item=>(
                                    <TableRow>
                                        <TableCell>{item.nome}</TableCell>
                                    </TableRow>
                                ))}
                                {iluminacaoState.map(item=>(
                                    <TableRow>
                                        <TableCell>{item.nome}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </DialogContent>
            <DialogActions>
                <FullWidthButton
                    disabled={false}
                    fullWidth={false}
                    color="primary"
                    variant="contained"
                    disableElevation
                    text={"Ok"}
                    onClick={() => {
                        onClose();
                    }}
                />
            </DialogActions>
        </Dialog>
        )}
    </>
};
export { ModalInfoInativos };